import { type } from "../../types/types";

export default function reducer(
  state = { returns: [], returnDetail: {}, pagination: {} },
  action
) {
  switch (action.type) {
    case type.SET_RETURNS:
      return { ...state, ...action.returns };
    case type.SET_RETURN_DETAIL:
      return { ...state, ...action.returnDetail };
    default:
      return { ...state };
  }
}
